
define(
	'TavanoTeam.TavanoTeam_Lazy_Loading_Extension.LazyLoading'
	, [
		'jQuery'
	]
	, function (
		jQuery
	) {

		'use strict';

		return {

			mountToApp: function mountToApp(container) {

				var environment = container.getComponent("Environment");
				var lazyEffectElements = environment.getConfig('tavanoTeamLazyLoading.elementsSelector').toString();

				if (!!lazyEffectElements) {

					var layout = container.getComponent('Layout');
					var elementScrollOffset = 200;
					var elementScrollDelay = 300; // (milliseconds) adjust to the highest acceptable value
					var lazyLoadingEnabled = true;
					var scrollHandling = true;
					var lastScrollPoint = 0;

					var resetScrollSettings = function () {

						if (jQuery('#main > .modal-open').length === 0) { // Avoid Modal
							lastScrollPoint = 0;
							lazyLoadingEnabled = true;
							scrollHandling = true;

							jQuery(lazyEffectElements).addClass("tt-lazyshow");
							jQuery(lazyEffectElements).removeClass("tt-lazyshowed");
							jQuery('.home > div.tt-lazyshow:nth-child(1)').removeClass('tt-lazyshow');
						}
					}

					var showElements = function (elementOffset) {

						var hasElements = false;

						jQuery('.tt-lazyshow').each(function (i) {

							hasElements = true;

							var bottom_of_element = jQuery(this).offset().top + elementOffset;

							var bottom_of_window = jQuery(window).scrollTop() + jQuery(window).height();

							if (bottom_of_window > bottom_of_element) {

								jQuery(this).removeClass("tt-lazyshow");
								jQuery(this).addClass("tt-lazyshowed");
							}
						});

						lazyLoadingEnabled = hasElements;
					};

					// Scrolling Down Detect Funtion
					var scrollingDown = function () {

						var actualScollPoint = jQuery(window).scrollTop();

						var scrollingDown = false;

						if (actualScollPoint > lastScrollPoint) {

							scrollingDown = true;
							lastScrollPoint = actualScollPoint;
						}

						return scrollingDown;
					}

					layout.on('afterShowContent', function () {

						resetScrollSettings();

						// Unhide elements on scroll
						jQuery(window).scroll(function () {

							if (lazyLoadingEnabled && scrollHandling) {

								if (scrollingDown()) {

									showElements(elementScrollOffset);

									// Lazy Loading Scroll frequency
									scrollHandling = false;

									var startLazyElementsFunction = function () {
										showElements(elementScrollOffset);
										scrollHandling = true;
										clearInterval(startLazyElementsInterval);
									};

									var startLazyElementsInterval = setInterval(startLazyElementsFunction, elementScrollDelay);
								}
							}
						});
					});

					// CMS Elements
					if (typeof CMS !== 'undefined') {

						// CMS Online
						CMS.on('page:content:set', function () {

							resetScrollSettings();
						});
					} else {

						// CMS Local
						Backbone.on('cms:loaded', function (cms) {

							cms.on('page:content:set', function () {

								resetScrollSettings();
							});
						});
					}
				}
			}
		};
	}
);
